import React, { useMemo, useState } from "react";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import * as walletAdapters from "@solana/wallet-adapter-wallets";
import {
  WalletModalProvider,
  WalletDisconnectButton,
  WalletMultiButton,
} from "@solana/wallet-adapter-react-ui";
import { clusterApiUrl } from "@solana/web3.js";

import TransactionForm from "../src/TransactionForm.jsx";

import TokenSelectorMenu from "./TokenSelectorMenu.jsx";

// Default styles that can be overridden by your app
require("@solana/wallet-adapter-react-ui/styles.css");

function App() {
  // The network can be set to 'devnet', 'testnet', or 'mainnet-beta'.
  const network = WalletAdapterNetwork.Devnet;

  // You can also provide a custom RPC endpoint.
  const endpoint = useMemo(() => clusterApiUrl(network), [network]);

  const wallets = useMemo(
    () => [
      new walletAdapters.BackpackWalletAdapter(),
      new walletAdapters.AlphaWalletAdapter(),
      new walletAdapters.AvanaWalletAdapter(),
      new walletAdapters.SlopeWalletAdapter(),
      new walletAdapters.SolflareWalletAdapter(),
      new walletAdapters.TorusWalletAdapter(),
      new walletAdapters.LedgerWalletAdapter(),
      new walletAdapters.SolletWalletAdapter({ network }),
      new walletAdapters.SolletExtensionWalletAdapter({ network }),
    ],
    [network]
  );

  const [selectedToken, setSelectedToken] = useState("test");

  return (
    <div
      style={{
        textAlign: "left",
        padding: "20px",
        width: "50%",
        margin: "auto"
      }}
    >
      <div
        style={{ marginBottom: "10vh",marginTop:"20vh", fontSize: "2em", fontWeight: "bold" }}
      >
        Solana Sender ({selectedToken?.symbol})
      </div>
      <ConnectionProvider endpoint={endpoint}>
        <WalletProvider wallets={wallets} autoConnect>
        <div>Step 1: Connect the wallet.</div>
          <WalletModalProvider>
            <WalletMultiButton
              style={{ margin: "10px",marginBottom:"5vh",  display: "inline-flex" }}
            />
            <WalletDisconnectButton
              style={{ margin: "10px", display: "inline-flex",display:"none" }}
            />
          </WalletModalProvider>
          <div>Step 2: Select token type</div>
          <TokenSelectorMenu setSelectedToken={setSelectedToken}/>

          <TransactionForm selectedToken={selectedToken}/>
        </WalletProvider>
      </ConnectionProvider>
    </div>
  );
}

export default App;
